export const BACKEND_URL = process.env.REACT_APP_URL_BACKEND;

export const WEBSOCKET_URL = process.env.REACT_APP_URL_WEBSOCKET;

export async function handleResponse(response: Response) {
  if (!response.ok) {
    throw new Error(`Error: ${response.statusText}`);
  }
  return await response.json();
}

export function getHeaders(accessToken?: string) {
  const headers: { [key: string]: string } = {
    "Content-Type": "application/json",
  };
  if (accessToken) {
    headers["Authorization"] = `Bearer ${accessToken}`;
  }
  return headers;
}
export function getHeadersPhoto(accessToken?: string) {
  const headers: { [key: string]: string } = {};
  if (accessToken) {
    headers["Authorization"] = `Bearer ${accessToken}`;
  }
  return headers;
}
